import { createSlice } from '@reduxjs/toolkit';



const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    profile: {},
  },
  reducers: {
    setProfile: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const { setProfile } = profileSlice.actions;

export default profileSlice.reducer;

export const selectProfile = (state) => state.profile.profile;
